module.exports = __webpack_public_path__ + "img/fx@2x.ff857e63.png";